<template>
  <div class="filtro-atributos col s2 pa-0 pl-1 mt-1" style="height: calc(100vh - 15rem); position: relative; z-index: 10;">
    <ul
      class="collapsible"
      data-collapsible="accordion"
      v-if="temFiltros"
      style="border-radius: 8px;"
    >
      <template v-for="(attr, key, index) in filtrosDaBusca">
        <li :key="'attr_' + key" style="border-radius: 8px;">
          <div
            class="collapsible-header"
            @click.prevent="accordionClick(key)"
            :style="getBorderStyle(index)"
          >
            <div class="row ma-0" v-if="filtrosSelecionados[key]">
              <div class="col s7 pa-0">
                <span class="primary-color-text">{{ obterNomeFiltro(key) }}</span>
                <span class="grey-text" v-if="filtrosSelecionados[key].length > 0">({{ filtrosSelecionados[key].length }})</span>
              </div>
              <div class="col s5 pa-0 pt-1 pb-1 right" v-if="filtrosSelecionados[key].length > 0">
                <a
                  class="btn-flat btn-small right"
                  style="font-size: 12px; border-radius: 4px; height: 22px; line-height: 4px; padding: 10px;"
                  @click.prevent="$emit('limparGrupo', filtrosDaBusca[key])"
                >
                  Limpar
                </a>
              </div>
            </div>
          </div>
          <div class="collapsible-body pa-0 pl-1" style="border: none;">
            <ul style="height: calc(100vh - 25rem); overflow: auto;">
              <li v-for="(filtro, idx) in attr" :key="`filtro_${key}_${idx}`">
                <input
                  class="filled-in-box"
                  type="checkbox"
                  :id="`checkbox-${key}-${idx}`"
                  :value="filtro"
                  v-model="filtrosSelecionados[key]"
                  @change="$emit('filtrarProdutos')"
                />
                <label class="primary-color-text" :for="`checkbox-${key}-${idx}`">{{ filtro }}</label>
              </li>
            </ul>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'filtro-atributos',
  props: {
    filtrosDaBusca: { type: Object, default: () => ({}) },
    filtrosSelecionados: { type: Object, required: true },
    filters: { type: Array, default: () => [] }
  },
  data() {
    return {
      ultimoAccordion: null
    };
  },
  computed: {
    temFiltros() {
      return Object.keys(this.filtrosDaBusca).some(key => this.filtrosDaBusca[key].length > 0);
    }
  },
  mounted() {
    this.$nextTick(() => {
      $('.collapsible').collapsible();
    });
  },
  methods: {
    accordionClick(id) {
      if (this.ultimoAccordion === id) {
        $('.collapsible').collapsible('close', id);
        this.ultimoAccordion = null;
      } else {
        $('.collapsible').collapsible('open', id);
        this.ultimoAccordion = id;
      }
    },
    getBorderStyle(index) {
      const total = Object.keys(this.filtrosDaBusca).length;
      if (index === 0) return 'border-top-left-radius: 8px; border-top-right-radius: 8px;';
      if (index === total - 1) return 'border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;';
      return '';
    },
    obterNomeFiltro(atributo) {
      const filtro = this.filters.find(f => f.atributo === atributo);
      return filtro ? filtro.menu : `Atributo ${atributo}`;
    }
  }
};
</script>


// WEBPACK FOOTER //
// FiltroAtributos.vue?946410d8